import React, { Component, Fragment } from "react";

// Page Politique de confidentialité (RGPD — Règlement UE 2016/679, notamment art. 13)
class Confidentialite extends Component {
  // Les liens étant en pied de page, on remonte en haut à l'ouverture de la page
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Fragment>
        <div className="page-title">
          <div className="container">
            <h1>Politique de confidentialité</h1>
          </div>
        </div>
        <div className="white-box inner-section">
          <div className="container">
            <section className="post mb35">
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  La société CINEVAUBAN attache une grande importance à la protection et au
                  respect de votre vie privée. La présente politique de confidentialité a pour
                  objet de vous informer, de manière claire et transparente, sur la façon dont
                  vos données à caractère personnel sont collectées et traitées lorsque vous
                  utilisez le site <strong>cinevauban.fr</strong>, conformément au Règlement
                  Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la
                  loi n° 78-17 du 6 janvier 1978 modifiée, dite « Informatique et Libertés ».
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Responsable du traitement</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Le responsable du traitement des données est :<br />
                  <strong>CINEVAUBAN</strong> (SAS)<br />
                  Siège social : 45 rue de la Croix Désilles, 35400 Saint-Malo<br />
                  SIRET : 838 697 449 000 26<br />
                  Email de contact : sgenouvrier@cinevauban.fr
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Données collectées et finalités</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Nous ne collectons que les données strictement nécessaires aux finalités
                  poursuivies. Sur ce site, les traitements sont les suivants :
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Formulaire de contact.</strong> Lorsque vous nous adressez un
                  message, nous collectons vos prénom et nom, votre ville (facultatif), votre
                  adresse email, votre numéro de téléphone (facultatif) et le contenu de votre
                  message. Finalité : traiter votre demande et y répondre. Base légale : votre
                  consentement (article 6.1.a du RGPD), recueilli au moment de l'envoi du
                  formulaire.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Navigation et fonctionnement du site.</strong> Des cookies
                  strictement nécessaires permettent de mémoriser vos préférences (notamment le
                  cinéma sélectionné). Finalité : assurer le bon fonctionnement du site. Base
                  légale : l'intérêt légitime de l'éditeur à fournir un service fonctionnel
                  (article 6.1.f du RGPD).
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  La vente de billets et d'abonnements (nom, prénom, email, coordonnées de
                  paiement) est opérée via le service de billetterie en ligne
                  ws.cinevauban.fr, qui fait l'objet de ses propres conditions et informations
                  relatives au traitement des données. Les paiements y sont traités par le
                  prestataire <strong>Monext Payline</strong>, prestataire de services de
                  paiement certifié PCI-DSS : les données de carte bancaire sont collectées
                  directement sur l'environnement sécurisé de Monext et ne sont pas conservées
                  par la société CINEVAUBAN.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Caractère obligatoire des données</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Les champs signalés comme obligatoires dans le formulaire de contact (prénom,
                  nom et adresse email) sont nécessaires au traitement de votre demande ; à
                  défaut, nous ne serions pas en mesure d'y répondre. Les autres champs sont
                  facultatifs.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Destinataires des données</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Vos données sont destinées exclusivement aux services internes habilités de
                  la société CINEVAUBAN en charge du traitement de votre demande. Elles ne sont
                  ni cédées, ni louées, ni vendues à des tiers à des fins commerciales.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  Pour les besoins techniques du service, vos données peuvent être hébergées
                  par notre prestataire d'hébergement, <strong>Infomaniak Network SA</strong>{" "}
                  (Genève, Suisse), agissant en qualité de sous-traitant au sens de l'article
                  28 du RGPD et présentant des garanties de conformité appropriées.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Transfert des données hors de l'Union européenne</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Nos données sont hébergées en Suisse, pays reconnu par la Commission
                  européenne comme assurant un niveau de protection adéquat des données à
                  caractère personnel. Aucun autre transfert de vos données en dehors de
                  l'Union européenne n'est réalisé.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Durée de conservation</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Les données transmises via le formulaire de contact sont conservées le temps
                  nécessaire au traitement de votre demande, puis supprimées ou archivées dans
                  un délai maximal de 12 mois à compter du dernier échange.
                  Les cookies de fonctionnement sont conservés pour une durée n'excédant pas
                  13 mois.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Sécurité des données</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  La société CINEVAUBAN met en œuvre les mesures techniques et organisationnelles
                  appropriées afin de protéger vos données contre la perte, l'altération, la
                  divulgation ou l'accès non autorisé, notamment la transmission sécurisée des
                  données via le protocole HTTPS et la limitation des accès aux seules personnes
                  habilitées.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Vos droits</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des
                  droits suivants sur vos données :
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>droit d'accès et d'information ;</li>
                  <li>droit de rectification des données inexactes ou incomplètes ;</li>
                  <li>droit à l'effacement (« droit à l'oubli ») ;</li>
                  <li>droit à la limitation du traitement ;</li>
                  <li>droit d'opposition au traitement ;</li>
                  <li>droit à la portabilité de vos données ;</li>
                  <li>droit de retirer votre consentement à tout moment, sans que cela ne
                    remette en cause la licéité du traitement effectué avant ce retrait ;</li>
                  <li>droit de définir des directives relatives au sort de vos données après
                    votre décès.</li>
                </ul>
                <p style={{ lineHeight: "1.8" }}>
                  Vous pouvez exercer ces droits en nous écrivant à sgenouvrier@cinevauban.fr,
                  en justifiant de votre identité. Nous nous engageons à répondre dans un délai
                  d'un mois à compter de la réception de votre demande.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Cookies</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Un cookie est un petit fichier déposé sur votre terminal lors de la visite du
                  site. Le site cinevauban.fr utilise uniquement des cookies strictement
                  nécessaires à son fonctionnement (mémorisation du cinéma sélectionné et de
                  vos préférences de navigation). Conformément à la réglementation, ces cookies
                  ne requièrent pas votre consentement préalable.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  Le site ne dépose aucun cookie publicitaire, de mesure d'audience ou de
                  traçage par des tiers ; aucun consentement préalable n'est donc requis. Vous
                  pouvez à tout moment configurer votre navigateur pour refuser ou supprimer
                  les cookies ; le refus des cookies nécessaires peut toutefois altérer le
                  fonctionnement du site.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Réclamation auprès de la CNIL</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  Si vous estimez, après nous avoir contactés, que vos droits ne sont pas
                  respectés, vous disposez du droit d'introduire une réclamation auprès de la
                  Commission Nationale de l'Informatique et des Libertés (CNIL), 3 place de
                  Fontenoy — TSA 80715 — 75334 Paris Cedex 07, ou en ligne sur www.cnil.fr.
                </p>
              </div>
            </section>

            <section className="post mb35">
              <div className="mb15">
                <h2 className="small text-center text-md-left">Modification de la politique</h2>
              </div>
              <div className="grey-bordered">
                <p style={{ lineHeight: "1.8" }}>
                  La présente politique de confidentialité est susceptible d'être modifiée à
                  tout moment afin de tenir compte des évolutions légales, réglementaires ou
                  techniques. La version applicable est celle en vigueur lors de votre
                  consultation du site.
                </p>
              </div>
            </section>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Confidentialite;
